<header
  class="flex flex-col min-h-[58px] justify-center align-middle min-h-12 text-sm px-6 gap-4 sm:flex-row sm:justify-between"
>
  <img
    src="../../assets/Forsta_Logo_Magenta_Navy_RGB_with_Germany_Tagline.svg"
    alt="forsta-logo"
    height="50px"
    width="144.67px"
    class="max-h-[50px] my-auto mx-auto sm:mx-0"
  />
  <nav class="text-primary justify-center flex font-medium h-14 sm:h-auto">
    <a (click)="login()" title="Login" class="px-4 hover:bg-accent-blue flex items-center">Login</a>
    <a (click)="signup()" title="Create An Account" class="px-4 hover:bg-accent-blue flex items-center"
      >Create An Account</a
    >
  </nav>
</header>
